export default __webpack_public_path__ + "static/media/7.7a951282.mp3";